export * from './PlusSmallIcon'
